module.exports = __webpack_public_path__ + "img/invest.2073e2be.png";